import * as React from 'react';

import {Popover} from 'shells/popover/popover';

import {useGetNotifications, useMarkNotificationRead} from '../../../sidebar/graphql/hooks';
import {NotificationList} from '../../../sidebar/notifications/notification-list';
import {useMarkAllSeen} from '../../../sidebar/notifications/use-mark-all-seen';

import {Header} from './header';

import styles from './notifications-popover.module.css';

type Props = {
    anchor: HTMLElement | null | undefined;
    onBlur: () => void;
    setIsNotificationsOpened: (arg1: boolean) => void;
    isNotificationsOpened: boolean;
};

export const NotificationsPopover = (props: Props) => {
    const [previouslyIsNotificationsOpened, setPreviouslyIsNotificationsOpened] =
        React.useState(false);

    const {notifications, isLoading, error, refetch, startPolling, stopPolling} =
        useGetNotifications();
    const markAllSeen = useMarkAllSeen();
    const {markRead} = useMarkNotificationRead();

    React.useEffect(() => {
        setPreviouslyIsNotificationsOpened(props.isNotificationsOpened);

        if (
            props.isNotificationsOpened &&
            props.isNotificationsOpened !== previouslyIsNotificationsOpened
        ) {
            refetch();
            markAllSeen();
            startPolling(30000);
        } else if (!props.isNotificationsOpened) {
            stopPolling();
        }
    }, [
        markAllSeen,
        refetch,
        previouslyIsNotificationsOpened,
        startPolling,
        stopPolling,
        props.isNotificationsOpened,
    ]);

    return (
        <Popover
            anchor={props.anchor}
            onBlur={props.onBlur}
            location='bottom-left'
            hideNub={true}
            offsetPosition={-5}
            customStyles={{
                maxHeight: 'calc(100vh - 40px)',
            }}
        >
            <div className={styles['popover-container']}>
                <Header
                    setIsNotificationsOpened={props.setIsNotificationsOpened}
                    notifications={notifications}
                    isLoading={isLoading}
                    error={error}
                    refetch={refetch}
                />
                <div className={styles['notification-list-container']}>
                    <NotificationList
                        notifications={notifications}
                        isLoading={isLoading}
                        errorMessage={error}
                        onMarkRead={(id: string) => {
                            markRead(id).then(() => {
                                refetch();
                            });
                        }}
                        closeSidebar={() => props.setIsNotificationsOpened(false)}
                    />
                </div>
            </div>
        </Popover>
    );
};
